/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Venue_Not_At_EventInputs */

const th_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามนี้ไม่ได้อยู่ในรายการสนามของรายการแข่งขันนี้ กรุณาเพิ่มสนามก่อน`)
};

const en_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That venue is not one of this event's courts. Add it to the event first.`)
};

const ja_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会場はこの大会のコートではありません。先に大会へ追加してください。`)
};

const zh_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该场馆不属于本赛事的球场。请先把它添加到赛事中。`)
};

const es_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese pabellón no es una de las pistas de este evento. Añádelo primero al evento.`)
};

const pt_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse ginásio não é uma das quadras deste evento. Adicione-o ao evento primeiro.`)
};

const id_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat itu bukan salah satu lapangan acara ini. Tambahkan dulu ke acaranya.`)
};

const fr_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette salle ne fait pas partie des terrains de cet événement. Ajoutez-la d’abord à l’événement.`)
};

const tl_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi isa sa mga court ng event na ito ang venue na iyon. Idagdag muna ito sa event.`)
};

const vi_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm đó không thuộc các sân của sự kiện này. Hãy thêm nó vào sự kiện trước.`)
};

const ko_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 경기장은 이 이벤트의 코트가 아닙니다. 먼저 이벤트에 추가하세요.`)
};

const de_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Halle gehört nicht zu den Feldern dieses Events. Füge sie zuerst dem Event hinzu.`)
};

const ru_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта площадка не входит в площадки данного события. Сначала добавьте её к событию.`)
};

const tr_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O salon bu etkinliğin sahalarından biri değil. Önce etkinliğe ekleyin.`)
};

const it_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'impianto non è tra i campi di questo evento. Aggiungilo prima all'evento.`)
};

const pl_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta hala nie należy do boisk tego wydarzenia. Najpierw dodaj ją do wydarzenia.`)
};

const uk_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей майданчик не належить до майданчиків цієї події. Спершу додайте його до події.`)
};

const hi_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह स्थल इस आयोजन के कोर्ट में नहीं है। पहले उसे आयोजन में जोड़ें।`)
};

const ar_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الصالة ليست من ملاعب هذه الفعالية. أضفها إلى الفعالية أولًا.`)
};

const ms_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat itu bukan antara gelanggang acara ini. Tambahkannya ke acara dahulu.`)
};

const bn_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই মাঠ এই আয়োজনের কোর্টের মধ্যে নেই। আগে সেটি আয়োজনে যোগ করুন।`)
};

const zh_tw2_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該場館不屬於本賽事的球場。請先將它加入賽事。`)
};

const zh_hk2_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該場館不屬於本賽事的球場。請先將它加入賽事。`)
};

const ur_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ مقام اس ایونٹ کے کورٹ میں شامل نہیں۔ پہلے اسے ایونٹ میں شامل کریں۔`)
};

const fa_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن سالن جزو زمین‌های این رویداد نیست. نخست آن را به رویداد بیفزایید.`)
};

const sw_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi huo si miongoni mwa viwanja vya tukio hili. Uongeze kwenye tukio kwanza.`)
};

const nl_err_venue_not_at_event = /** @type {(inputs: Err_Venue_Not_At_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die zaal hoort niet bij de velden van dit evenement. Voeg hem eerst toe aan het evenement.`)
};

/**
* | output |
* | --- |
* | "That venue is not one of this event's courts. Add it to the event first." |
*
* @param {Err_Venue_Not_At_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_venue_not_at_event = /** @type {((inputs?: Err_Venue_Not_At_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Venue_Not_At_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_venue_not_at_event(inputs)
	if (locale === "ja") return ja_err_venue_not_at_event(inputs)
	if (locale === "zh") return zh_err_venue_not_at_event(inputs)
	if (locale === "es") return es_err_venue_not_at_event(inputs)
	if (locale === "pt") return pt_err_venue_not_at_event(inputs)
	if (locale === "id") return id_err_venue_not_at_event(inputs)
	if (locale === "fr") return fr_err_venue_not_at_event(inputs)
	if (locale === "tl") return tl_err_venue_not_at_event(inputs)
	if (locale === "vi") return vi_err_venue_not_at_event(inputs)
	if (locale === "ko") return ko_err_venue_not_at_event(inputs)
	if (locale === "de") return de_err_venue_not_at_event(inputs)
	if (locale === "ru") return ru_err_venue_not_at_event(inputs)
	if (locale === "tr") return tr_err_venue_not_at_event(inputs)
	if (locale === "it") return it_err_venue_not_at_event(inputs)
	if (locale === "pl") return pl_err_venue_not_at_event(inputs)
	if (locale === "uk") return uk_err_venue_not_at_event(inputs)
	if (locale === "hi") return hi_err_venue_not_at_event(inputs)
	if (locale === "ar") return ar_err_venue_not_at_event(inputs)
	if (locale === "ms") return ms_err_venue_not_at_event(inputs)
	if (locale === "bn") return bn_err_venue_not_at_event(inputs)
	if (locale === "zh-TW") return zh_tw2_err_venue_not_at_event(inputs)
	if (locale === "zh-HK") return zh_hk2_err_venue_not_at_event(inputs)
	if (locale === "ur") return ur_err_venue_not_at_event(inputs)
	if (locale === "fa") return fa_err_venue_not_at_event(inputs)
	if (locale === "sw") return sw_err_venue_not_at_event(inputs)
	if (locale === "nl") return nl_err_venue_not_at_event(inputs)
	return en_err_venue_not_at_event(inputs)
});